import React from 'react'
import { Slide } from 'pure-react-carousel'
import { useIsXs } from 'hooks/responsive'
import { Carousel } from 'components/Slider'
import { ReactComponent as SwipeSvg } from 'resources/svg/icons/hand-pointer.svg'
import { ComparisonContainer, SliderContainer } from '../../styled'
import { ProductToCompare } from '../ProductToCompare'
import { EmptyColumn } from '../EmptyColumn'
import { useComparisonContext } from 'lib/modules/catalog'

export const Products = () => {
  const isMobile = useIsXs()
  const { getProductsToCompare } = useComparisonContext()
  const productsToCompare = getProductsToCompare()

  return (
    <>
      {isMobile ? (
        <SliderContainer>
          <Carousel
            child={productsToCompare}
            renderChildren={(children: Array<{ file: string, id: number }>) => {
              return productsToCompare?.map((product, i: number) => {
                if (product) {
                  return (
                    <Slide index={i} key={i}>
                      <ProductToCompare index={i} sku={product} />
                    </Slide>
                  )
                } else {
                  return (
                    <Slide index={i} key={i}>
                      <EmptyColumn />
                    </Slide>
                  )
                }
              })
            }}
            arrowsEnabled
            autoHeight
          />
          <div className='carousel__bottom'>
            <SwipeSvg />
            Swipe to compare
          </div>
        </SliderContainer>
      ) : (
        <ComparisonContainer>
          {productsToCompare?.map((product, index: number) => {
            if (product) {
              return <ProductToCompare key={index} index={index} sku={product} />
            } else {
              return <EmptyColumn key={index} />
            }
          })}
        </ComparisonContainer>
      )}
    </>
  )
}
